import React from 'react';
import { useState } from 'react';
import { useContext } from 'react';
import { Link } from 'react-router-dom';

import axios_api from '../Api';
import { API_URL, AUTH_TOKEN } from '../Context';
import Loader from './common/Loader';

//import { STATUSES, GetTaskStatus, GetStatusTableClass, GetStatusTextClass } from './Task';


function CalendarWidget({tasks}) {
  // Получаем текущую дату
  const now = new Date();
  const currentMonth = now.getMonth(); // 0-11
  const currentYear = now.getFullYear();

  // Названия месяцев на русском
  const monthNames = [
    'Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь',
    'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'
  ];

  // Функция для парсинга даты в формате DD-MM-YYYY
  const parseDate = (dateString) => {
    if (!dateString) return null;
    
    // Проверяем формат DD-MM-YYYY или DD.MM.YYYY
    const parts = dateString.split(/[-./]/);
    if (parts.length === 3) {
      const day = parseInt(parts[0], 10);
      const month = parseInt(parts[1], 10) - 1; // месяцы начинаются с 0
      const year = parseInt(parts[2], 10);
      return new Date(year, month, day);
    }
    
    // Если формат другой, пытаемся парсить напрямую
    return new Date(dateString);
  };

  // Группируем задачи по месяцам
  const tasksByMonth = {};
  
  tasks.forEach(task => {
    if (task.deadline_date) {
      const date = parseDate(task.deadline_date);
      if (date && !isNaN(date.getTime())) {
        const month = date.getMonth();
        const year = date.getFullYear();
        
        // Проверяем, что дата в текущем году
        if (year === currentYear) {
          const key = `${year}-${month}`;
          if (!tasksByMonth[key]) {
            tasksByMonth[key] = [];
          }
          tasksByMonth[key].push({
            ...task,
            day: date.getDate()
          });
        }
      }
    }
  });

  // Определяем, с какого месяца начинать отображение:
  // по умолчанию с текущего, но если есть задачи
  // в прошедших месяцах, то с самого раннего месяца с задачами
  let firstMonth = currentMonth;
  const monthKeys = Object.keys(tasksByMonth);
  if (monthKeys.length > 0) {
    const monthsWithTasks = monthKeys.map(key => {
      const [, monthStr] = key.split('-');
      return parseInt(monthStr, 10);
    });
    const earliestMonthWithTasks = Math.min(...monthsWithTasks);
    if (earliestMonthWithTasks < currentMonth) {
      firstMonth = earliestMonthWithTasks;
    }
  }

  // Создаем массив месяцев от первого отображаемого до конца года
  const months = [];
  for (let month = firstMonth; month < 12; month++) {
    const key = `${currentYear}-${month}`;
    const monthTasks = tasksByMonth[key] || [];
    
    // Сортируем задачи по дням
    monthTasks.sort((a, b) => a.day - b.day);
    
    months.push({
      month,
      year: currentYear,
      name: monthNames[month],
      tasks: monthTasks
    });
  }

  return (
    <div className="m-3">
      {months.map((monthData) => (
        <div 
          key={`${monthData.year}-${monthData.month}`}
          className={ monthData.tasks.length > 0 ? "mb-3 p-3 calendar-month" : "mb-3 p-3 calendar-disabled-month"}
          style={{
            borderRadius: '8px',
            color: 'grey'
          }}
        > 
          { monthData.tasks.length > 0 ?
            <h6 className="mb-3 fw-bold">{monthData.name} {monthData.year}</h6>
          :
            <p className="mb-3 fw-bold">{monthData.name} {monthData.year}</p>
          }
          {monthData.tasks.length > 0 ? (
            <div className="mt-2">
              {monthData.tasks.map((task, index) => (
                <Link 
                  to={`/task/${task.id}`}
                  className="flex-grow-1"
                >
                  <div 
                    key={index}
                    className={task.status === 'OUTDATED' ? 
                      "d-flex mb-2 p-3 bg-danger text-danger-emphasis bg-opacity-25 align-items-center justify-content-between" : 
                      "d-flex mb-2 p-3 bg-primary text-primary-emphasis bg-opacity-10 align-items-center justify-content-between"
                    }
                    style={{
                      borderRadius: '4px',
                      fontSize: '0.9rem',
                      minHeight: '80px',
                    }}
                  >
                    <span className="">{task.form.replace(/#.*#/g, "")}</span>

                    { task.status === 'OUTDATED' ? 
                      <div className="">
                        <p className="m-0 fw-bold d-flex justify-content-end">Просрочено!</p>
                        <p className="m-0 fw-bold d-flex justify-content-end">{task.deadline_date}</p>
                      </div>
                    : 
                      <span className="ms-2 fw-bold">{task.deadline_date}</span>
                    }
                  </div>
                </Link>
              ))}
            </div>
          ) : (
            <div style={{ fontSize: '0.85rem', opacity: 0.8 }}>
              Нет заданий
            </div>
          )}
        </div>
      ))}
    </div>
  );
}


export default function TasksCalendar ({selectedYear}) {

  const[tasks, setTasks] = useState([]);
  const [loading, setLoading] = useState(true);
  const api_url = useContext(API_URL);
  const token = useContext(AUTH_TOKEN);


  React.useEffect(() => {

    let taskList = axios_api.get(api_url + '/user_tasks/', {
      headers: {"Authorization": token},
      params: {"year": selectedYear}
    });

    taskList.then(
      (result) => {
        let tasks = []

        // filtering statuses for Calendar
        for (let task in result.data) {
          if (['OUTDATED', 'RETURNED', 'AVAILABLE','IN_PROGRESS', 'PENDING'].includes(result.data[task].status)) {
            tasks.push(result.data[task])
          }
        }
        setTasks(tasks);
        setLoading(false);
      },
      (error) => {
        console.log(error)
        setLoading(false);
      }
    );

  }, []);

  return loading ? (
    <Loader/>
  ) : (
    <>
      <div className='row'>
        <h3 className='m-3'>Задания - календарь предоставления результатов</h3>
      </div>
      <div className='row'>
        <div className='col-xxl-6 col-xl-8 col-9'>
          <CalendarWidget tasks={tasks} />
        </div>
      </div>
    </>  
  )
}

